<template>
  <div class="card" @click="onChange">
    <div class="img">
      <el-image v-if="obj.projectId" :src="obj.picturePath" fit="cover"></el-image>
    </div>
    <div class="img">
      <el-image v-if="obj.packageId" :src="obj.picUrl" fit="cover"></el-image>
    </div>
    <div class="img">
      <el-image v-if="obj.productId" :src="obj.picUrl" fit="cover"></el-image>
    </div>
    <!-- 项目 -->
    <div class="content" v-if="obj.projectId">
      <div class="title">{{ obj.projectName }}</div>
      <div class="price">
        <span>￥{{ obj.price }}</span>
        <span>/{{ obj.projectCount }}次</span>
      </div>
    </div>
    <!-- 套餐 -->
    <div class="content" v-if="obj.packageId">
      <div class="title">{{ obj.packageName }}</div>
      <div class="price">
        <span>￥{{ obj.price }}</span>
      </div>
    </div>
    <!-- 产品 -->
    <div class="content" v-if="obj.productId">
      <div class="title">{{ obj.productName }}</div>
      <div class="price">￥{{ obj.salePrice }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    obj: Object,
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    onChange() {
      this.$emit("change", this.obj)
    },
  },
}
</script>

<style scoped lang="scss">
.card {
  width: 156px;
  height: 236px;
  border-radius: 10px;
  background-color: #f4f6f9;
  margin-right: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  cursor: pointer;
  .img {
    border-bottom: 1px solid #e3e5e8;
    .el-image {
      display: block;
      width: 156px;
      height: 156px;
    }
  }
  .content {
    width: 100%;
    height: 80px;
    font-size: 14px;
    padding: 8px 10px;
    box-sizing: border-box;
    .title {
      color: #0f1c40;
      height: 40px;
      line-height: 19px;
      display: -webkit-box;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .price {
      color: #ee1a1a;
    }
  }
}
</style>
